import React, { ChangeEvent } from 'react';
import { useAreasQuery } from '../hooks';
import { LcaObjectCustomFactor } from '../index.types';
import { TextField } from '@mui/material';
import PageLoading from 'src/components/PageLoading';
import { isValidDecimalInput } from 'src/Lca/utils/number';

interface CustomFactorsFieldsProps {
  values: LcaObjectCustomFactor[];
  handleChange: (
    _e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    _id: number
  ) => void;
  errors: { [key: string]: string };
  isLoading: boolean;
}

export default function CustomFactorsFields({
  values,
  handleChange,
  errors,
  isLoading,
}: CustomFactorsFieldsProps) {
  const impactAreas = useAreasQuery();
  const [inputValues, setInputValues] = React.useState<Record<number, string>>(
    {}
  );

  if (!impactAreas) {
    return <PageLoading />;
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '20px',
      }}
    >
      {impactAreas.map((area) => {
        const factorValue =
          values.find((value) => value.area_id === area.id)?.factor ?? '';
        const displayValue =
          inputValues[area.id] ??
          (factorValue === '' ? '' : String(factorValue));
        return (
          <TextField
            key={area.id}
            fullWidth
            name={area.name}
            type="text"
            value={displayValue}
            onChange={(e) => {
              if (
                !isValidDecimalInput(e.target.value, {
                  allowNegative: true,
                })
              ) {
                return;
              }

              setInputValues((prevValues) => ({
                ...prevValues,
                [area.id]: e.target.value,
              }));
              handleChange(e, area.id);
            }}
            disabled={isLoading}
            error={!!errors[area.name]}
            helperText={errors[area.name]}
            label={`${area.name} (${area.unit_name})`}
            inputProps={{ inputMode: 'decimal' }}
            onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
          />
        );
      })}
    </div>
  );
}
